export { default } from "./internal/EmailLink"
